import { render } from "./Combobox.vue?vue&type=template&id=5904dab5&lang=pug"
import script from "./Combobox.vue?vue&type=script&lang=ts"
export * from "./Combobox.vue?vue&type=script&lang=ts"

import "./Combobox.vue?vue&type=style&index=0&id=5904dab5&lang=scss"
script.render = render

export default script